import { Component, OnInit } from '@angular/core';
import {RawSoldPlate} from "../../models/registration";
import {AdminService} from "../../services/admin-service";

@Component({
  selector: 'pla-admin-multiple-sales',
  templateUrl: './admin-multiple-sales.component.html',
  styleUrls: ['./admin-multiple-sales.component.scss']
})
export class AdminMultipleSalesComponent implements OnInit {

  public loading: boolean = false;
  public plateStyle: string = 'dateless';
  displayedColumns: string[] = ['registration', 'sold_price', 'sold_date', 'seller'];
  public results: RawSoldPlate[] = [];
  public uniqueResultCount: number = 0;

  constructor(private adminService: AdminService) { }

  ngOnInit(): void {
    this.searchPlates();
  }

  public plateStyleChanged(event: any): void {
    this.plateStyle = event.value;
    this.searchPlates();
  }

  public searchPlates(): void {
    this.loading = true;
    this.adminService.MultipleSales(this.plateStyle, (res) => {
      if (res) {
        this.loading = false;
        this.results = [...res];
        this.uniqueResultCount = Array.from(
          new Map(res.map(item => [item.registration, item])).values()
        ).length;
      } else {
        this.results = [];
        this.uniqueResultCount = 0;
        alert('No results found or an error occurred.');
      }
    });
  }

  public exportResults(): void {
    // res as csv
    if (this.results.length === 0) {
      alert('No results to export.');
      return;
    }
    const csvContent = this.results.map((r: RawSoldPlate) => {
      return `${r.formattedRegistration},${(Number.parseInt(r.sold_price) / 100).toFixed(2)},${r.sold_date},${r.seller || ''}`;
    }).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `${this.plateStyle}_multiple_verified_sales.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    alert('Results exported as .csv');
  }
}
